<template>
    <section class="why-choose-us-section service">
        <div class="container-right">
            <div class="why-choose-us-section--inner">
                <div class="section-title-box">
                    <h3 class="section-title">Наши работы</h3>
                </div>
                <div class="section-contnir">
                    <div class="section-single-div" v-for="tab in tabsList" :key="tab.id">
                        <h4 class="section-single-div-title">{{ tab.title }}</h4>
                        <div class="main-content__img-box">
                        <img :src="tab.imgUrl" class="main-content__img" :alt="tab.title" />
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import {ref} from 'vue';

const selectedTab = ref(null);

function openSelectedTab (val) {
    if(selectedTab.value === val) {
        selectedTab.value = null
    } else  {
        selectedTab.value = val
    }
}
const tabsList = ref([
    {
        id: 1,
        title: 'Мангали',
        imgUrl: 'images/why-choose-us/03.jpeg'
    },
    {
        id: 2,
        title: 'Решотки',
        imgUrl: 'images/why-choose-us/03.jpeg'
    },
    {
        id: 3,
        title: 'Ворота',
        imgUrl: 'images/why-choose-us/03.jpeg'
    },
    {
        id: 4,
        title: 'Лестница',
        imgUrl: 'images/why-choose-us/03.jpeg'
    },
])

selectedTab.value = 'Innovative Designs'
</script>
<style scoped>
.fade-up-enter-active,
.fade-up-leave-active {
    transition: all 0.3s ease-in-out;
}
.fade-up-enter,
.fade-up-leave-to {
    height: 0;
    transform: translateY(30px);
    opacity: 0;
}
</style>
